const C = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        d="M73.4375 20.9375L73.625 20.8125C73.25 20.125 72.6875 19.5 72.125 19.1875L41.9375 1.8125C41.4375 1.5 40.75 1.375 40 1.375C39.25 1.375 38.5625 1.5625 38.0625 1.8125L8.0625 19.25C7 19.875 6.25 21.4375 6.25 22.625V57.4375C6.25 58.125 6.375 58.875 6.8125 59.5625L6.6875 59.625C7 60.125 7.4375 60.5625 7.875 60.8125L38 78.25C38.5 78.5625 39.1875 78.6875 39.9375 78.6875C40.6875 78.6875 41.375 78.5 41.875 78.25L71.875 60.8125C72.9375 60.1875 73.6875 58.625 73.6875 57.4375V22.5625C73.75 22.0625 73.6875 21.5 73.4375 20.9375ZM40 55.3125C45.6875 55.3125 50.6875 52.1875 53.3125 47.5625L61.375 52.3125C57.125 59.6875 49.125 64.6875 40 64.6875C26.375 64.6875 15.3125 53.625 15.3125 40C15.3125 26.375 26.375 15.3125 40 15.3125C49.1875 15.3125 57.1875 20.375 61.4375 27.8125L53.3125 32.5C50.6875 27.8125 45.6875 24.6875 40 24.6875C31.5625 24.6875 24.6875 31.5625 24.6875 40C24.6875 48.4375 31.5625 55.3125 40 55.3125Z"
        fill="#03599C"
      />
    </svg>
  );
};

export default C;
